import { InjectionToken } from '@angular/core';

export const TYPEFORM_CONFIG = new InjectionToken<TypeformConfig>('TYPEFORM_CONFIG');

export interface TypeformConfig {
  clientId: string;
  /** e.g.: /typeform */
  relativeRedirectUrl: string;
}
